"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DashboardPanelLink = void 0;

var _reactRouterDom = require("react-router-dom");

var _react = _interopRequireDefault(require("react"));

var _atoms = require("../../atoms");

require("./DashboardPanelLink.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// Dashboard Panel Link
var DashboardPanelLink = function DashboardPanelLink(_ref) {
  var to = _ref.to,
      href = _ref.href,
      icon = _ref.icon,
      title = _ref.title,
      trkAction = _ref.trkAction,
      handleClick = _ref.handleClick,
      color = _ref.color,
      props = _ref.props;

  if (to) {
    return /*#__PURE__*/_react.default.createElement(_atoms.Element, _extends({
      color: color,
      link: true,
      href: to,
      className: "link",
      onClick: handleClick,
      "data-trk-act": trkAction
    }, props), icon && /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
      type: icon
    }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
      type: _atoms.Label.Type.Body
    }, title));
  } else if (href) {
    return /*#__PURE__*/_react.default.createElement(_atoms.Element, _extends({
      color: color,
      tag: "a",
      href: href,
      className: "link",
      onClick: handleClick,
      trkAction: trkAction
    }, props), icon && /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
      type: icon
    }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
      type: _atoms.Label.Type.Body
    }, title));
  } else {
    return /*#__PURE__*/_react.default.createElement(_atoms.Element, _extends({
      color: color,
      touchable: true,
      className: "link",
      onClick: handleClick,
      trkAction: trkAction
    }, props), icon && /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
      type: icon
    }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
      type: _atoms.Label.Type.Body
    }, title));
  }
};

exports.DashboardPanelLink = DashboardPanelLink;
DashboardPanelLink.defaultProps = {
  color: _atoms.Color.Trace
};